import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import DiscountGateway from '~apis/discount';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { PayloadAction } from '@reduxjs/toolkit';
import { TUpdateDiscountsSettingsReduxParams } from '~types/feat/setting';

export default function* watchUpdateDiscountsSettings(api: DiscountGateway): SagaWatcherReturnType {
    yield takeEvery('setting/settingUpdateDiscountAttempt', handleUpdateDiscountsSettings, api);
}

function* handleUpdateDiscountsSettings(api: DiscountGateway, data: PayloadAction<TUpdateDiscountsSettingsReduxParams>) {
    const state = store.getState();

    const authToken = state.auth.userDetails.authToken;
    const params = data.payload;

    const response = yield* call([api, api.updateDiscountsSettings], { authToken, ...params });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.settingUpdateDiscountFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.settingUpdateDiscountSuccess(response.data));
        yield put(combinedActions.settingSetProductManagementDiscountDetailsModalIsOpen(false));
        yield put(combinedActions.settingSetProductManagementDiscountDeleteModalIsOpen(false));
        yield put(combinedActions.settingSetProductManagementDiscountDetailsModalIsEditing(false));
        toast.success(SuccessMessages.DiscountDetailsUpdateSuccess);
    }
}
